import { render, staticRenderFns } from "./ButtonTarget.vue?vue&type=template&id=1700ef8e&scoped=true&"
import script from "./ButtonTarget.vue?vue&type=script&lang=js&"
export * from "./ButtonTarget.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTarget.vue?vue&type=style&index=0&id=1700ef8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1700ef8e",
  null
  
)

export default component.exports